export const PROJECTION_POSITIONS = ["QB", "RB", "WR", "TE", "DST"];

export const PROJECTION_COLUMNS = [
  { Header: "Name", accessor: "name", sortDescFirst: false },
  { Header: "Pos", accessor: "position", sortDescFirst: false },
  { Header: "Team", accessor: "team", sortDescFirst: false },
  { Header: "Opp", accessor: "opp", sortDescFirst: false },
  { Header: "H/A", accessor: "homeAway", sortDescFirst: false },
  { Header: "Spread", accessor: "pointSpread" },
  { Header: "Game Total", accessor: "gameTotal" },
  { Header: "Implied TT", accessor: "impliedTt" },
  { Header: "Proj Points", accessor: "projPoints" },
  { Header: "Proj Own", accessor: "projOwnership" },
  { Header: "DK Salary", accessor: "salary" },
  { Header: "% of DK Salary", accessor: "percentDkSalary" },
  { Header: "DK $ Value", accessor: "dkDollarValue" },
];

export function toProjectionRows(projections) {
  return projections.map((row) => {
    const next = { ...row };
    if (row.slatePlayer) {
      next.dkPlayerId = row.slatePlayer.id;
    }
    return next;
  });
}

export function filterProjectionRows(rows, { positions, teams }) {
  return rows.filter((row) => {
    const teamOk = teams.length === 0 || teams.includes(row.team);
    const positionOk = positions.length === 0 || positions.includes(row.position);
    return teamOk && positionOk;
  });
}
